/* eslint-disable @typescript-eslint/no-var-requires */
import phoenixResortsCarousel from './lib/phoenixResortsCarousel.graphql';
import phoenixLeisureSearchByKeyword from './lib/phoenixLeisureSearchByKeyword.graphql';
import phoenixLeisureDestinationPropertiesByGeolocation from './lib/phoenixLeisureDestinationPropertiesByGeolocation.graphql';
import phoenixLeisureDestinationPropertiesByLocation from './lib/phoenixLeisureDestinationPropertiesByLocation.graphql';
import phoenixLeisureSearchLowestAvailableRatesByGeolocation from './lib/phoenixLeisureSearchLowestAvailableRatesByGeolocation.graphql';
import phoenixLeisureSearchLowestAvailableRatesByLocation from './lib/phoenixLeisureSearchLowestAvailableRatesByLocation.graphql';
import PhoenixSearchPropertiesByArea from './lib/PhoenixSearchPropertiesByArea.graphql';
import phoenixLeisureSearchPropertiesByLocation from './lib/phoenixLeisureSearchPropertiesByLocation.graphql';
import phoenixStorefrontDestinationProperties from './lib/PhoenixSearchPropertiesByGeolocation.graphql';
import phoenixLeisureSearchPropertiesByGeolocation from './lib/phoenixLeisureSearchPropertiesByGeolocation.graphql';
import phoenixLeisureSearchPropertiesByIds from './lib/phoenixLeisureSearchPropertiesByIds.graphql';
import phoenixLeisureExchangeRateByCurrencyCodes from './lib/phoenixLeisureExchangeRateByCurrencyCodes.graphql';

export {
  phoenixResortsCarousel,
  phoenixLeisureSearchByKeyword,
  phoenixLeisureDestinationPropertiesByGeolocation,
  phoenixLeisureDestinationPropertiesByLocation,
  PhoenixSearchPropertiesByArea,
  phoenixLeisureSearchPropertiesByLocation,
  phoenixStorefrontDestinationProperties,
  phoenixLeisureSearchPropertiesByGeolocation,
  phoenixLeisureSearchLowestAvailableRatesByGeolocation,
  phoenixLeisureSearchLowestAvailableRatesByLocation,
  phoenixLeisureSearchPropertiesByIds,
  phoenixLeisureExchangeRateByCurrencyCodes,
};
